// extracted by mini-css-extract-plugin
export default {"auth-wrapper":"AuthPage_auth-wrapper__ubmoD","left-side":"AuthPage_left-side__h-hH+","main-auth":"AuthPage_main-auth__vgAE7","auth-header":"AuthPage_auth-header__Jeus0"};